import Image from 'next/image';
import {
  FilledMailIcon,
  FilledPhoneIcon,
} from '../components/elements/svgIcon/filled';

export const publicIcon = (
  <Image
    alt="public"
    className=""
    src="/icons/public.svg"
    width={22}
    height={22}
  />
);
export const protectedIcon = (
  <Image
    alt="protected"
    className=""
    src="/icons/protected.svg"
    width={22}
    height={22}
  />
);
export const privateIcon = (
  <Image
    alt="private"
    className=""
    src="/icons/private.svg"
    width={22}
    height={22}
  />
);

export const viewPermissionValue = {
  Public: 'public',
  Protected: 'protected',
  Private: 'private',
};

export const viewPermissionData = [
  { name: 'Công khai', value: viewPermissionValue.Public },
  { name: 'Người theo dõi bạn', value: viewPermissionValue.Protected },
  { name: 'Chỉ mình tôi', value: viewPermissionValue.Private },
];

export const listViewPermissionIcon = [
  {
    icon: publicIcon,
    name: 'public',
  },
  {
    icon: protectedIcon,
    name: 'protected',
  },
  {
    icon: privateIcon,
    name: 'private',
  },
];

export const groupPrivacyIcons = [
  {
    icon: publicIcon,
    name: 'Public',
  },
  {
    icon: privateIcon,
    name: 'Private',
  },
];

export const contactTypeIcon = (
  <Image
    alt=""
    className=""
    src="/icons/ContactType.svg"
    width={22}
    height={22}
  />
);

export const placeHolderForEachContactType = [
  {
    contactType: '',
    placeholder: '',
  },
  {
    contactType: 'personalEmail',
    placeholder: 'Nhập email cá nhân',
  },
  {
    contactType: 'personalPhone',
    placeholder: 'Nhập số điện thoại cá nhân',
  },
  {
    contactType: 'workEmail',
    placeholder: 'Nhập email công việc',
  },
  {
    contactType: 'workPhone',
    placeholder: 'Nhập số điện thoại công việc',
  },
];

export const listIconContact = [
  {
    icon: <FilledPhoneIcon width={22} height={22} />,
    name: 'personalPhone',
  },
  {
    icon: <FilledMailIcon width={22} height={22} />,
    name: 'personalEmail',
  },
  {
    icon: <FilledPhoneIcon width={22} height={22} />,
    name: 'workPhone',
  },
  {
    icon: <FilledMailIcon width={22} height={22} />,
    name: 'workEmail',
  },
];

export const listIconContactForModal = [
  {
    icon: <></>,
    name: '',
  },
  ...listIconContact,
];

export const contactTypeData = [
  {
    name: 'Số điện thoại cá nhân',
    value: 'personalPhone',
  },
  {
    name: 'Email cá nhân',
    value: 'personalEmail',
  },
  {
    name: 'Số điện thoại công việc',
    value: 'workPhone',
  },
  {
    name: 'Email công việc',
    value: 'workEmail',
  },
];

export const socialMediaData = [
  { name: 'Facebook', value: 'facebook' },
  { name: 'Messenger', value: 'messenger' },
  { name: 'Instagram', value: 'instagram' },
  { name: 'Twitter', value: 'twitter' },
  { name: 'Skype', value: 'skype' },
  { name: 'LinkedIn', value: 'linkedIn' },
  { name: 'Whatsapp', value: 'whatsapp' },
  { name: 'TikTok', value: 'tiktok' },
  { name: 'Reddit', value: 'reddit' },
  { name: 'Discord', value: 'discord' },
  { name: 'Pinterest', value: 'pinterest' },
  { name: 'Dribble', value: 'dribble' },
  { name: 'YouTube', value: 'youtube' },
  { name: 'Behance', value: 'behance' },
  { name: 'Telegram', value: 'telegram' },
  { name: 'Tumblr', value: 'tumblr' },
  { name: 'Spotify', value: 'spotify' },
];

export const socialMediaUrls = [
  { name: 'facebook', url: 'https://www.facebook.com/' },
  { name: 'messenger', url: 'https://www.messenger.com/' },
  { name: 'instagram', url: 'https://www.instagram.com/' },
  { name: 'twitter', url: 'https://twitter.com/' },
  { name: 'skype', url: 'https://www.skype.com/' },
  { name: 'linkedIn', url: 'https://www.linkedin.com/' },
  { name: 'whatsapp', url: 'https://wa.me/' },
  { name: 'tiktok', url: 'https://www.tiktok.com/' },
  { name: 'reddit', url: 'https://www.reddit.com/' },
  { name: 'discord', url: 'https://discord.com/' },
  { name: 'pinterest', url: 'https://www.pinterest.com/' },
  { name: 'dribble', url: 'https://dribbble.com/' },
  { name: 'youtube', url: 'https://www.youtube.com/' },
  { name: 'behance', url: 'https://www.behance.net/' },
  { name: 'telegram', url: 'https://web.telegram.org/' },
  { name: 'tumblr', url: 'https://www.tumblr.com/' },
  { name: 'spotify', url: 'https://open.spotify.com/user/' },
];

export const listIconSocialLink = socialMediaData.map((social, _index) => {
  return {
    icon: (
      <Image
        alt=""
        priority
        className=""
        src={`/icons/${social.name}.svg`}
        width={22}
        height={22}
      />
    ),
    name: social.value,
  };
});

export const SUITABLE_TEXT_MAX_LINE = 2;
export const LENGTH_SEE_MORE_TEXT = 11;

const BIO_SUITABLE_TEXT_MAX_LENGTH_PER_LINE = 39;
const SUITABLE_TEXT_MAX_LENGTH_PER_LINE = 28;

export const SUITABLE_TEXT_MAX_LENGTH =
  SUITABLE_TEXT_MAX_LENGTH_PER_LINE * SUITABLE_TEXT_MAX_LINE;

export const SUITABLE_TEXT_LENGTH =
  SUITABLE_TEXT_MAX_LENGTH - LENGTH_SEE_MORE_TEXT;

export const SUITABLE_TEXT_MAX_WIDTH = SUITABLE_TEXT_MAX_LENGTH_PER_LINE;

export const BIO_SUITABLE_TEXT_MAX_LENGTH =
  BIO_SUITABLE_TEXT_MAX_LENGTH_PER_LINE * SUITABLE_TEXT_MAX_LINE;

export const BIO_SUITABLE_TEXT_LENGTH =
  BIO_SUITABLE_TEXT_MAX_LENGTH - LENGTH_SEE_MORE_TEXT;

export const BIO_SUITABLE_TEXT_MAX_WIDTH =
  BIO_SUITABLE_TEXT_MAX_LENGTH_PER_LINE;
